/*
 * Function return days word in polish grammar context
 * */
export default numberOfDays => {
  return numberOfDays === 1 ? "day" : "days";
};
